<script lang="ts">
    import type { RoutePicture } from "../Model/RoutePicture";
    import DateFormat from "./DateFormat.svelte";
    import Slide from "./Slide.svelte";
    import Slider from "./Slider.svelte";
    
    export let routePictures: RoutePicture[];
    export let showPicture: RoutePicture | null = null;

</script>

<style lang="scss">

    .route-picture-slider {
        height: 100%;
        background-color: #5D5D5D;

    }

    .route-picture {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .image {
        max-width: calc(100% - 2rem);
        max-height: calc(100% - 2rem);
        box-shadow: 0 2px 6px #2b2b2b;
    }

    .image-wrapper {
        flex: 1 1 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .user-info {
        box-sizing: border-box;
        padding: 0.5rem;
        height: 4rem;
        background-color: #fff;
        display: flex;
        align-items: center;     
        justify-content: center;   
        width: 100%;
    }

    .user-image {
        $size: 2rem;
        width: $size;
        height: $size;
        margin-right: 0.5rem;
        border-radius: 50%;
    }

    .upload-date {
        font-size: 0.8em;
    }

</style>

<div class="route-picture-slider">
    <Slider slideTo={showPicture}>
        {#each routePictures as routePicture}
        <Slide index={routePicture}>
            <div class="route-picture">
                <div class="image-wrapper">
                    <img class="image" src={routePicture.medium} alt="">
                </div>
                {#if routePicture.meta.user_name}
                <div class="user-info">
                    <img class="user-image" src={routePicture.meta.user_image} alt="">
                    <div class="user-meta">
                        <div class="user-name">{routePicture.meta.user_name}</div>
                        <div class="upload-date">
                            <DateFormat date={routePicture.createdDate} />
                        </div>
                    </div>
                </div>
                {/if}
            </div>
        </Slide>
        {/each}
    </Slider>
</div>
